import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { StyledSimpleLink } from 'components/Shared/style';

export default class ImporterLink extends PureComponent {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.string,
            PropTypes.element
        ]).isRequired,
        onChange: PropTypes.func
    }

    static defaultProps = {
        onChange: () => null
    }

    input = null;

    handleChange = () => {
        this.props.onChange(this.input);
        this.input.value = null;
    }

    handleRef = (ref) => {
        this.input = ref;
    }

    render() {
        return (
            <StyledSimpleLink className="ui-simple-link">
                {this.props.children}
                <input
                    type="file"
                    onChange={this.handleChange}
                    ref={this.handleRef}
                />
            </StyledSimpleLink>
        );
    }
}
